import { FC } from 'react';
import { useForm } from 'react-hook-form';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { useIsDesktop } from '@/shared/hooks/use-is-desktop';
import { CreateBeneficiaryModalProps } from '@/widgets/modals/types';

import { ModalContainerV1 } from '../containers/ModalContainerV1';

import { CreateForm, FormData } from './CreateForm';

export const CreateBeneficiaryModal: FC<CreateBeneficiaryModalProps> = ({
  title,
  description,
  btnText,
  onSubmit,
}) => {
  const isDesktop = useIsDesktop();
  const form = useForm<FormData>();

  return (
    <ModalContainerV1 title={title}>
      <CreateForm
        form={form}
        onSubmit={onSubmit}
        description={description ? <span style={{ fontWeight: 700 }}>{description}</span> : null}
        submitBtn={
          <ButtonIw
            htmlType="submit"
            block={!isDesktop}
            loading={form.formState.isSubmitting}
            disabled={form.formState.isSubmitting}
          >
            {btnText}
          </ButtonIw>
        }
      />
    </ModalContainerV1>
  );
};
